import React, { useEffect, useRef, memo, useState } from "react";
import Camera from "../Sub_components/Camera";
import MediaDeviceSelector from "../Sub_components/MediaDeviceSelector";
import VagaroLogo from "../Sub_components/VagaroLogo";
import ToggleSwitchComponent from "../Components/ToggleSwitchComponent";
import { useLiveStreamAppContext } from "../ContextStore/Store";
import { CallBackGivenForDismiss } from "../utils/AppUtils";
import IframeModal from "../PopupModal/IframeModal";
import { getDeviceInfoDetails } from "../utils/PlatformCheck";
import { AmplitudeAddLog } from "../utils/AppAmplitude";
import BodyClassUpdater from "../utils/BodyClassUpdater";
import StartLiveStream from "../GeneralFunctions/StartLiveStream";
import Permission from "../GeneralFunctions/Permission";
import ClassAppointmentExitPopup from '../PopupModal/EndCallModal'
import { getBrowserPermissionSteps } from "../utils/getBrowserPermissionSteps";
import TroubleshootingModal from "../PopupModal/TroubleshootingModal";
function HostAttendeePreviewScreen() {
  const [videoStream, setVideoStream] = useState(null);
  const childButtonRef = useRef();
  const panelRef = useRef(null);
  const deviceInfoDetails = getDeviceInfoDetails();
  const { startClassCall } = StartLiveStream();
  const [shouldRender, setShouldRender] = useState(true);
  const { checkPermissions } = Permission();

  const {
    classesName,
    role,
    loaderAnimation,
    eventType,
    isCam,
    isMic,
    setIsCam,
    setIsMic,
    setInformationContent,
    setShowInformationStrip,
    setIsMuted,
    setShowUrl,
    setShowIframe,
    webUrlSubDomain,
    totalLicenseRequired,
    showIframe,
    __merchantId,
    __userId,
    appInsightTrack,
    __appConfirmUniqueID,
    grp,
    businessURL,
    isGearSettingVisible,
    setGearSettingVisible,
    toggleGearMobile,
    setToggleStates,
    isMobile,
    isAndroidTablet,
    previewVideoEffects,
    previewLocalVideoStream,
    previewView,
    microphonePermission,
    cameraPermission,
    permissionError,
    toggleStates,
  } = useLiveStreamAppContext();
  const [isCameraEnabled, setIsCameraEnabled] = useState(false);
  const [isMicrophoneEnabled, setIsMicrophoneEnabled] = useState(false);
  const [showtheModal, setshowtheModal] = useState(false);
  const [showTroubleshoot, setShowTroubleshoot] = useState(false);

  useEffect(() => {
    // Check initial permissions
    checkPermissions();

    // Set up interval to check for permission changes
    // (Note: There's no direct event for permission changes, so we poll)
    const interval = setInterval(checkPermissions, 1000);

    return () => clearInterval(interval);
  }, []);

  //Function to add or remove the class based on the state
  function toggleClass(selector, className, state) {
    const element = document.querySelector(selector);
    if (!element) {
      console.error("Element not found.");
      return;
    }
    if (state) {
      element.classList.add(className);
    } else {
      element.classList.remove(className);
    }
  }

  //Function to check the input Name field from the input box if it is not present
  function checkInput() {
    const inputField = document.getElementById("attendee_name");
    if (inputField?.value.trim() === "") {
      return false;
    }
    return true;
  }

  useEffect(() => {
    AmplitudeAddLog(__userId, __merchantId, businessURL, 107, grp, __appConfirmUniqueID);
  }, [__userId])

  //useEffect for Displaying Live Stream Number of License Required Popup
  useEffect(() => {
    if (totalLicenseRequired > 0 && role === "Presenter") {
      AmplitudeAddLog(__userId, __merchantId, businessURL, 112, grp, __appConfirmUniqueID);

      if (process.env.REACT_APP_PARENT_DOMAIN?.trim().toLowerCase() === "bookitall.com") {
        setShowUrl(process.env.REACT_APP_WEB_URL_SUBDOMAIN + "ShopOwner/LiveStreamReactVagaroPopup.aspx?popuptype=license&lic=" + totalLicenseRequired);  
      }
      else{
      setShowUrl("https://" + grp + "." + process.env.REACT_APP_PARENT_DOMAIN + "/ShopOwner/LiveStreamReactVagaroPopup.aspx?popuptype=license&lic=" + totalLicenseRequired);
      }
      setShowIframe(true); // Show profile after alert
    }
  }, [totalLicenseRequired, role])

  //Toggle Camera Button icon
  const toggleLocalVideo = () => {

    if (cameraPermission === "granted") {

      toggleClass("#cam_icon", "va-video-slash", isCam);
      setIsCam((prevState) => !prevState);
      if (isCam) {
        setToggleStates((prev) => ({
          ...prev,
          mirrorMyVideo: false,
          blurBackground: false,
        }));
        let blurBackground = document.getElementById("blurBackgrounddiv");
        !blurBackground?.classList.contains("divDisabled") && blurBackground?.classList.add("divDisabled");
        let mirrorMyVideo = document.getElementById("mirrorMyVideodiv");
        !mirrorMyVideo?.classList.contains("divDisabled") && mirrorMyVideo?.classList.add("divDisabled");
      } else {
        let blurBackground = document.getElementById("blurBackgrounddiv");
        blurBackground?.classList.contains("divDisabled") && blurBackground?.classList.remove("divDisabled");
        let mirrorMyVideo = document.getElementById("mirrorMyVideodiv");
        mirrorMyVideo?.classList.contains("divDisabled") && mirrorMyVideo?.classList.remove("divDisabled");
      }
    } else if (cameraPermission !== "granted") {
      setIsCameraEnabled(true);
    }
  };

  //Toggle Microphone Button icon
  const toggleLocalAudio = () => {
    if (microphonePermission === "granted") {
      toggleClass("#mic_icon", "va-microphone-slash", isMic);
      setIsMic((prevState) => !prevState);
      setIsMuted((prevState) => !prevState);
      setToggleStates((prev) => ({
        ...prev,
        removeBackgroundNoise: false,
      }));
      if (isMic) {
        let removeBackgroundNoise = document.getElementById(
          "removeBackgroundNoisediv"
        );
        !removeBackgroundNoise?.classList.contains("divDisabled") &&
          removeBackgroundNoise?.classList.add("divDisabled");
      } else {
        let removeBackgroundNoise = document.getElementById(
          "removeBackgroundNoisediv"
        );
        removeBackgroundNoise?.classList.contains("divDisabled") &&
          removeBackgroundNoise?.classList.remove("divDisabled");
      }
    } else if (microphonePermission !== "granted") {
      setIsMicrophoneEnabled(true);
    }
  };

  const navigateInMacSafari = () => {
    if (
      navigator.userAgent.includes("Macintosh") &&
      /^((?!chrome|android).)*safari/i.test(navigator.userAgent)
    ) {
      const currentPath = window.location.pathname;
      const newPath = currentPath.replace("/start", "/meeting");
      window.open(newPath + window.location.search, "_self");
    }
  };

  //Function for Start Live Stream Button Click
  const handleStartClass = () => {
    if (cameraPermission !== "granted" && microphonePermission !== "granted") {
      //console.log("Permissions not granted. Button click ignored.");
      return;
    }
    if (videoStream) {
      videoStream.getTracks().forEach((track) => track.stop());
      setVideoStream(null);
    }
    sessionStorage.removeItem("end");
    if (role === "Attendee") {
      if (checkInput()) {
        if (previewVideoEffects?.activeEffects?.length > 0) {
          previewVideoEffects.stopEffects().then(() => {
            if (previewView) {
              previewView?.dispose();
            }
            if (previewVideoEffects) {
              previewVideoEffects?.dispose();
              previewVideoEffects?.disposeEffectEventSubscriptions();
            }
            if (previewLocalVideoStream) {
              previewLocalVideoStream?.dispose();
              previewLocalVideoStream?.disposeRawStream();
            }

            // 3. Remove all leftover canvas elements (ACS may create multiple)
            // const canvases = document.querySelectorAll("canvas");
            // canvases.forEach((canvas) => canvas.remove());

            document.getElementById("removeVideoTile").remove();
            // Hide everything by updating state
            setShouldRender(false);
            startClassCall().then(() => {
              navigateInMacSafari();
            });
          });
        } else {
          startClassCall().then(() => {
            navigateInMacSafari();
          });
        }
      } else {
        setShowInformationStrip(true);
        setInformationContent({
          type: "warn",
          message: "Please enter screen name",
        });
      }
    } else {
      if (previewVideoEffects?.activeEffects?.length > 0) {
        previewVideoEffects.stopEffects().then(() => {
          if (previewView) {
            previewView?.dispose();
          }
          if (previewVideoEffects) {
            previewVideoEffects?.dispose();
            previewVideoEffects?.disposeEffectEventSubscriptions();
          }
          if (previewLocalVideoStream) {
            previewLocalVideoStream?.dispose();
            previewLocalVideoStream?.disposeRawStream();
          }
          // 3. Remove all leftover canvas elements (ACS may create multiple)
          // const canvases = document.querySelectorAll("canvas");
          // canvases.forEach((canvas) => canvas.remove());
          document.getElementById("removeVideoTile").remove();
          // Hide everything by updating state
          setShouldRender(false);
          startClassCall().then(() => {
            navigateInMacSafari();
          });
        });
      } else {
        startClassCall().then(() => {
          navigateInMacSafari();
        });
      }
    }
  };

  const cancelCall = () => {
    AmplitudeAddLog(__userId, __merchantId, businessURL, 115, grp, __appConfirmUniqueID);
    setTimeout(() => {
      CallBackGivenForDismiss();
      if (deviceInfoDetails.isMobileApp && !deviceInfoDetails.isAndroid) {
        try {
          window.close();
        } catch (e) {
          appInsightTrack(__merchantId, __userId, "Preview Screen Dismiss", "", e);
        }
        window.location.href = role === "Presenter" ? 'closewindowpro://closewindowProURL' : 'closewindow://closewindowURL';
      } else {
        window.close();
      }
    }, 1500);
  };

  const handleClickOutside = (event) => {
    if (panelRef.current && !panelRef.current.contains(event.target)) {
      setGearSettingVisible(false);
    }
  };

  useEffect(() => {
    if (isGearSettingVisible) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isGearSettingVisible]);

  return shouldRender ? (
    <div>
      <BodyClassUpdater />
      <IframeModal />
      {!showIframe && (
        <div
          className="livestream-wrapper-new"
          style={{ display: loaderAnimation ? "none" : "flex" }}
        >
          <div className="player-setting-popup">

            <div className="psp-header section-avatar-title">
              <div>
                <a href className="close-icon close-web" onClick={cancelCall}>
                  <i
                    className="fa-solid fa-xmark font-awesome-solid-pro"
                    aria-hidden="true"
                  ></i>
                </a>
              </div>
              <VagaroLogo />
              <div className="avatar-title-box margin-top-0">
                <h2>{classesName}</h2>
              </div>
            </div>

            <div className="psp-content video-audio-layout">
              <div className="ipadVerticalCenter">
                <div className="video-audio-layout">
                  <div className="col-video">
                    <div className="section-video">
                      <Camera
                        ref={childButtonRef}
                        toggleLocalAudio={toggleLocalAudio}
                        toggleLocalVideo={toggleLocalVideo}
                        videoStream={videoStream}
                        setVideoStream={setVideoStream}
                      />
                    </div>
                    <div className="video-overlay-black"></div>
                    <ToggleSwitchComponent
                      toggleLocalAudio={toggleLocalAudio}
                      toggleLocalVideo={toggleLocalVideo}
                    />
                  </div>
                  <div className="col-audio">
                    <MediaDeviceSelector />
                  </div>
                </div>
              </div>
            </div>
            <div className="psp-footer section-action">
              <div className="block-controls host-Setting">

                <div className="controls-btn previewBtn controls-btn-relative">
                  <i
                    id="MobShowHideVideoIconAtt"
                    className={`icon fas font-awesome-solid-pro va-video ShowHideVideoIcon ${cameraPermission !== "granted" && "divDisabled va-video-slash"
                      } ${!isCam && "va-video-slash"}`}
                    aria-hidden="true"
                    onClick={toggleLocalVideo}
                  ></i>
                  {cameraPermission !== "granted" && (
                    <i
                      className="icon-warning-bell icon font-awesome-solid-pro va-exclamation-triangle mb-icon icon-warning-bell"
                      title="Camera and microphone are disabled"
                    />
                  )}
                </div>
                <div className="controls-btn controls-btn-relative">
                  <i
                    id="MobShowHideSoundIconAtt"
                    className={`icon fas font-awesome-solid-pro va-microphone ShowHideSoundIcon ${microphonePermission !== "granted" && "divDisabled va-microphone-slash"
                      } ${!isMic && "va-microphone-slash"}`}
                    aria-hidden="true"
                    onClick={toggleLocalAudio}
                  ></i>
                  {microphonePermission !== "granted" && (
                    <i
                      className="icon font-awesome-solid-pro va-exclamation-triangle mb-icon icon-warning-bell"
                      title="Camera and microphone are disabled"
                    />
                  )}
                </div>
                <div className="controls-btn" onClick={() => toggleGearMobile()}>
                  <i
                    className={`icon fas font-awesome-solid-pro fa-gear ShowHideVideoIcon`}
                    aria-hidden="true"
                  ></i>
                </div>
                <div className="controls-btn" title="Troubleshoot camera & audio" onClick={() => setShowTroubleshoot(true)}>
                  <i
                    className="icon fas font-awesome-solid-pro fa-stethoscope"
                    aria-hidden="true"
                  ></i>
                </div>
              </div>
              <button
                className="troubleshoot-btn"
                onClick={() => setShowTroubleshoot(true)}
              >
                <i className="fas font-awesome-solid-pro fa-stethoscope" aria-hidden="true"></i>
                Troubleshoot camera & audio
              </button>
              <button
                className="cbtn brd-btn margin-right16"
                onClick={cancelCall}
              >
                Cancel
              </button>
              <button className={`cbtn thm-btn ${cameraPermission !== "granted" && microphonePermission !== "granted"
                  ? "divDisabled2"
                  : ""
                }`}
                onClick={(e) => {
                  if (cameraPermission !== "granted" && microphonePermission !== "granted") {
                    // Show popup or toast here
                    e.preventDefault();
                    //console.log("Show permission popup");
                    setshowtheModal(true)
                    // showPopup("Please grant camera and microphone access.");
                    return;
                  }
                  handleStartClass();
                }}
              >
                <div>
                  {`${role === "Presenter" ? "Start" : "Join"} ${eventType === 1 ? "Appointment" : "Class"
                    }`}
                </div>
              </button>
            </div>
          </div>
        </div>
      )}
      {
        showtheModal && (
          <ClassAppointmentExitPopup
            show={showtheModal}
            onHide={() => setshowtheModal(false)}
            message={getBrowserPermissionSteps("microphone")}
            buttontext={"Open Browser Settings"}
            headtext={"Allow Vagaro to Access Camera/Microphone"}
          />
        )
      }
      {showTroubleshoot && (
        <TroubleshootingModal
          show={showTroubleshoot}
          onHide={() => setShowTroubleshoot(false)}
        />
      )}
      {(isMobile || isAndroidTablet) && (
        <div
          className={`right-side-panel ${isGearSettingVisible ? "gearSettingIn" : ""
            }`}
          id="mobileRightSidePanel"
        >
          <div className="section-settings custom-scroll gear-setting">
            <div>
              <MediaDeviceSelector panelReff={panelRef} />
            </div>
          </div>
        </div>
      )}
      <div
        className={`rightSlideOverlay ${isGearSettingVisible ? "rightSlideOverlay-show" : ""
          }`}
      ></div>
    </div>
  ) : null;
}

export default memo(HostAttendeePreviewScreen);